import { HttpErrorResponse } from '@angular/common/http';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const MakePaymentAuthApiActions = createActionGroup({
  source: 'Make Payment - Auth API',
  events: {
    'Load User Success': emptyProps(),
    'Load User Error': props<{ error: HttpErrorResponse }>(),
  },
});
